import React from "react";
import ResponsibleGaming from "../../Rules/Responsiblegaming";
import { Helmet } from "react-helmet";
const ResponseGame = () => {
  return (
    <>
      <Helmet>
        <title>Responsible Gaming | BettDraft Fantasy Sports</title>
        <meta name="description" content="BettDraft is committed to responsible gaming. Learn about our tools and resources." />
      </Helmet>
      <ResponsibleGaming />
    </>
  );
};

export default ResponseGame;
